import { FormBase, FormJoin } from '@shared/interfaces/form';
import { HazmatPermit } from '@shared/enums/form';
import { Subject } from '@shared/enums/subject';
import { EMAIL } from '@shared/constants/base';

export const baseFormInitial: FormBase = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  extraInfo: '',
  subject: Subject.ContactUs,
  to: EMAIL,
};

export const joinFormInitial: FormJoin = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  dateOfBirth: '',
  country: 'United States',
  email: '',
  state: '',
  postalCode: '',
  hazmatPermit: HazmatPermit.No,
  subject: Subject.ApplyToJoin,
  to: 'nina.z@jffreight.com',
};
